'use client';

import Link from 'next/link';
import { WarningIcon } from '@phosphor-icons/react/dist/ssr';
import { FormProvider } from 'react-hook-form';
import { FORGOT_PATHNAME } from '@/shared/constants/pathnames';
import { StatusMessage } from '@/shared/ui/core/status-message';
import { Button, Text } from '@/shared/ui/core';
import { CredentialsFields } from '@/shared/ui/forms/credentials-fields';
import { UserProfileFields } from '@/shared/ui/forms/user-profile-fields';
import { useTeamSignup } from '../model/use-team-signup';
import styles from './team-signup-form.module.scss';


type ComponentProps = {
    email: string | null;
    token: string;
};


export function TeamSignupForm ({ email, token }: ComponentProps) {
    const { form, formError, loginHref, onSubmit, submitting, suggestLogin } = useTeamSignup({ email, token });

    return (
        <FormProvider { ...form }>
            <form
                className={ styles.form }
                data-template='team-signup-form'
                noValidate
                onSubmit={ onSubmit }
            >
                {
                    formError && !suggestLogin &&
                    <StatusMessage status='destructive'>
                        <Text
                            size='lg'
                            tone='destructive'
                            weight='semibold'
                            lineHeight={ 1.2 }
                        >
                            { formError }
                        </Text>
                    </StatusMessage>
                }

                <UserProfileFields/>
                <CredentialsFields/>

                {
                    suggestLogin &&
                    <div className={ styles.exists_warning }>
                        <WarningIcon
                            size={ 20 }
                            weight='fill'
                            className={ styles.warning_icon }
                        />
                        <Text
                            size='md'
                            tone='warning'
                        >
                            Looks like you already have an account. Try to{ ' ' }
                            <Link
                                href={ loginHref }
                                className={ styles.link }
                            >
                                log in
                            </Link>
                            { ' ' }or{ ' ' }
                            <Link
                                href={ FORGOT_PATHNAME }
                                className={ styles.link }
                            >
                                reset your password
                            </Link>.
                        </Text>
                    </div>
                }

                <Button
                    type='submit'
                    loading={ submitting }
                    fullWidth
                >
                    Create account and join the team
                </Button>
            </form>
        </FormProvider>
    );
}
